
<template>
    <div
        v-if="item"
        :class="{
            'tile': true,
            'tile--size-height-twice': !forceSmallTile && item.tile.doubleHeight,
            'tile--size-width-twice': !forceSmallTile && item.tile.doubleWidth,
            'tile--loading': loading
        }"
    >
        <div v-if="loading" class="tile__loader">
            <loader-element :loading="loading" />
        </div>
        <router-link
            :to="{ path: `/${item.url}` }"
            @click.native="$emit('navigated')"
            class="tile__link"
        >
            <div class="tile__categories">
                <span
                    v-for="(category, index) in item.categories"
                    class="tile__category"
                    :key="`category-item-${index}`"
                    :style="{ backgroundColor: category.color }"></span>
            </div>
            <div class="tile__text">
                <span v-if="item.tile.extraline" class="tile__extraline">{{ item.tile.extraline }}</span>
                <span v-if="item.tile.headline" class="tile__headline">{{ item.tile.headline }}</span>
            </div>
        </router-link>
        <image-element
            v-if="item.tile.image"
            :image="item.tile.image"
            :settings="item.tile.imageSettings"
        ></image-element>
    </div>
</template>

<script>
import ImageElement from '@/components/elements/ImageElement.vue';
import LoaderElement from '@/components/elements/LoaderElement.vue';

export default {
    name: 'TileElement',
    components: {
        ImageElement,
        LoaderElement,
    },
    props: {
        item: Object,
        loading: Boolean,
        forceSmallTile: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>
